// 725/825 are merchant rate-agreement thresholds; the lower values are the norms-tier floors.
export const ERS_SCORE_OPTIONS: number[] = [850, 825, 800, 775, 750, 725, 700, 665, 635, 605, 550]
